export const business = {
  name: 'Square & Compass Notary',
  owner: 'Michael Kidd',
  description:
    'Professional mobile notary and document support services throughout Northwest Arkansas.',
  siteUrl:
    import.meta.env.VITE_SITE_URL ||
    'https://www.squareandcompassnotary.com',
  phone: '',
  email: 'orders@squareandcompassnotary.com',
  hours: '',
  mailingAddress: '',
  serviceArea: 'Greater Northwest Arkansas Area',
  googleBusinessProfileUrl: '',
  socialLinks: [] as Array<{ label: string; url: string }>,
  appointmentPath: '/request-appointment',
  legalDisclaimer:
    'Square & Compass Notary is a notary and document support business and does not provide legal advice. Michael Kidd cannot select legal forms or advise you on the legal effect of a document. Consult a licensed attorney when legal guidance is needed.',
} as const

export const hasPublishedPhone = Boolean(business.phone)
export const hasPublishedEmail = Boolean(business.email)
